import { buildRouteAStar } from "./route.js";
import {
  getRegionDetails,
  calculateDistance,
  getPostalCodeDetails
} from "./postalCode.js";

export function approximatePrice(postalCode, region) {
  const regionRange = region.maxCode - region.minCode;
  const postalCodeInKm = region.radiusKm / (regionRange / 4);
  const distance = (postalCode - region.minCode) * postalCodeInKm;
  const price = Math.round(distance * 0.75 * 100) / 100;
  return price;
}

export const approximateRoutePrice = (route) => {
  const parts = route.length;
  if (parts === 2) {
    return 19.9;
  } else {
    return 19.9 * (parts - 1);
  }
};

const validatePostalCode = (postalCode) => {
  const postalCodeStr = postalCode.toString().padStart(5, "0");
  const postalCodeRegex = /^\d{5}$/;
  if (!postalCodeRegex.test(postalCodeStr)) {
    return '00100'
  }
  return postalCodeStr;
};

export function calculatePrice(originPostal, destinationPostal) {
  // If invalid throw error
  const postalCodeFrom = validatePostalCode(originPostal);
  const postalCodeTo = validatePostalCode(destinationPostal);

  // For same postalcode we should also do regioncheck
  // For now this is ok
  if (postalCodeFrom === postalCodeTo) {
    // Could be next to the shop
    // Could also be 9999 - 9999
    return 19.9
  }

  const fromDetails = getPostalCodeDetails(postalCodeFrom);
  const toDetails = getPostalCodeDetails(postalCodeTo);

  const fromRegionName = fromDetails.region;
  const toRegionName = toDetails.region;

  const sameRegion = fromRegionName === toRegionName

  // Close distance
  if (sameRegion) {
    const distance = calculateDistance(
      fromDetails.lat,
      fromDetails.lng,
      toDetails.lat,
      toDetails.lng
    );

    const price = calculatePriceForDistance(distance);
    return Math.round(price.price * 100) / 100;
  } else {
      let firstMilePrice = 0;
      let lastMilePrice = 0;
      const regionDetailsFrom = getRegionDetails(fromRegionName)

      const requiresFirstMileDelivery = false
      // temp set to false
      //`${postalCodeFrom}` !== `${regionDetailsFrom.postalCode}`;

      if (requiresFirstMileDelivery) {

      const distance = calculateDistance(
        fromDetails.lat,
        fromDetails.lng,
        regionDetailsFrom.lat,
        regionDetailsFrom.lng
      );
      const price = calculatePriceForDistance(distance);
      firstMilePrice = Math.round(price.price * 100) / 100;
    }
    const regionDetailsTo = getRegionDetails(toRegionName)

    const requiresLastMileDelivery =
      `${postalCodeTo}` !== `${regionDetailsTo.postalCode}`;
    if (requiresLastMileDelivery) {

      const distance = calculateDistance(
        toDetails.lat,
        toDetails.lng,
        regionDetailsTo.lat,
        regionDetailsTo.lng
      );
      const price = calculatePriceForDistance(distance);
      lastMilePrice = Math.round(price.price * 100) / 100;
    }

    const route = buildRouteAStar(
      regionDetailsFrom.postalCode,
      regionDetailsTo.postalCode
    );
    const routePrice = approximateRoutePrice(route);
    const totalPrice = Math.round((firstMilePrice + routePrice + lastMilePrice) * 100) / 100;
    return totalPrice
  }
}

// PK-Seutu (Helsinki Metropolitan Area) Distance Calculator
export const ecommerceRegionalConfig =
    [
    {
      description: "0-10 km",
      min_distance: 0,
      max_distance: 10,
      price: 15,
    },
    {
      description: "10-20 km",
      min_distance: 10,
      max_distance: 20,
      price: 19.9,
    },
    {
      description: "20-30 km",
      min_distance: 20,
      max_distance: 30,
      price: 29.9,
    },
    {
      description: "30+ km",
      min_distance: 30,
      max_distance: 999,
      base_price: 29.9,
      per_km_rate: 0.7,
      formula: "29.9 + (etäisyys - 30) * 0.7/km",
    }
]

export function calculatePriceForDistance(drivingDistance) {
  console.log('drivingDistance', drivingDistance)
  // Find the appropriate pricing tier
  for (const tier of ecommerceRegionalConfig) {
    // Check if distance falls within this tier's range
    if (drivingDistance >= tier.min_distance && drivingDistance < tier.max_distance) {
      
      if (tier.price !== undefined) {
        // Fixed price tier
        return {
          price: tier.price,
          tier: tier.description,
          calculation: `Fixed price for ${tier.description}`,
          distance: drivingDistance
        };
      } else if (tier.base_price !== undefined && tier.per_km_rate !== undefined) {
        // Variable price tier (13+ km)
        const extraDistance = drivingDistance - tier.min_distance;
        const calculatedPrice = tier.base_price + (extraDistance * tier.per_km_rate);
        
        return {
          price: Math.round(calculatedPrice * 100) / 100, // Round to 2 decimal places
          tier: tier.description,
          calculation: `${tier.base_price} + (${drivingDistance} - ${tier.min_distance}) × ${tier.per_km_rate} = ${calculatedPrice.toFixed(2)}`,
          basePrice: tier.base_price,
          extraDistance: Math.round(extraDistance * 100) / 100,
          perKmRate: tier.per_km_rate,
          distance: drivingDistance
        };
      }
    }
  }
  
  // Fallback if no tier matches (shouldn't happen with proper configuration)
  return {
    price: null,
    tier: 'Unknown',
    calculation: 'No pricing tier found for this distance',
    distance: drivingDistance,
    error: 'Distance outside of pricing range'
  };
}